import React, { useEffect, useRef, useState } from "react";
import { useFrame, useThree } from "@react-three/fiber";

import "./Galaxy.css"

import { TextureLoader } from "three";

import * as THREE from "three"
import { v } from "../../env/env_variable";


import { useStateValue } from '../../utils/provider/StateProvider';
import { hasSelectionSupport } from "@testing-library/user-event/dist/utils";
import { Html } from "@react-three/drei";
import Ring from "./Ring";

function Planet(props) {
    // REDUX STATES:
    const [{searchText}, dispatch] = useStateValue();
    const [viewType, setViewType] = useState(null)

    const [isFocuseSearch , setIsFocusSearch] = useState(false)
    const [isFocused, setIsFocused] = useState(false);
    const [refresh, setRefresh] = useState(true)

    // args:
    const radius = props.radius

    const initialPosition = {
      x: Math.random() * v.orbitScale,
      y: Math.random() * v.orbitScale,
      z: Math.random() * v.orbitScale,
    };

    useEffect(() => {

    }, [refresh])

    useEffect(() => {
      if(searchText===props.data.name){
        handlePlanetClick()
        setViewType("search")
        setIsFocusSearch(true)
        props.onSetPlanetData(props.data)
      }

      if(searchText === null){
        console.log("search Text ix null")
        setIsFocusSearch(false)
        setViewType(null)
        props.onSetPlanetData("closeSearch")
      }
    }, [searchText])



    const meshRef = useRef(null);

    // Load the texture to planet:
    const textureLoader = new TextureLoader();
    const texture = textureLoader.load(require(`${props.data.textures.base}`));

    // const texture = textureLoader.load(require(`../assets/texture/earth.jpg`));


    const { camera } = useThree();
    const hideDataThreshold = 10; // Define your threshold value
    const cameraPosition = camera.position;
    const shouldHideData = cameraPosition.z > hideDataThreshold;

    const handlePlanetClick = (type = "other") => {
      setViewType("click"); 
      
      
      if(type === 'click'){
        setIsFocused(!isFocused)
        props.onSetPlanetData(props.data)

        // Planet
        const planetElements = document.querySelectorAll('[id^="planetNameClicked"]');
        for (const planetElement of planetElements) {
          planetElement.style.display = 'none';
        }

      }
      
      
      setRefresh(!refresh)
    };
    
    // Manage the exntric orbit
    let planetPosition
    useFrame((state, delta) => {
        let data = props.data;

        const currentTime = state.clock.elapsedTime; // Elapsed time in seconds
        const orbitalPeriod = props.data.orbitalPeriod ; // Orbital period in seconds

        // Calculate the angle based on the elapsed time and orbital period
        const angle = (currentTime / orbitalPeriod) * 2 * Math.PI;

        let semimajorAxis = data.semimajorAxis / v.orbitScale;
        let eccentricity = data.eccentricity / v.orbitScale;
        let inclination = (Math.PI / 180) * data.inclination;

        // Calculate the current angle of the planet in its elliptical orbit
        const normalizedTime = state.clock.elapsedTime % data.orbitalPeriod;
        const trueAnomaly = (2 * Math.PI * normalizedTime) / data.orbitalPeriod;

        // Calculate the radius at the current true anomaly
        const radius = (semimajorAxis * (1 - eccentricity ** 2)) / (1 + eccentricity * Math.cos(trueAnomaly));

        // Calculate the x, y, z positions
        const x = radius * Math.cos(angle);
        const y = 0;
        const z = radius * Math.sin(angle);

        // Apply inclination if needed
        const inclinationMatrix = new THREE.Matrix4().makeRotationX(inclination);
        const position = new THREE.Vector3(x, y, z).applyMatrix4(inclinationMatrix);

        
        // Update the planet's position
        meshRef.current.position.set(position.x*v.distanceScalingFactor, position.y*v.distanceScalingFactor, position.z*v.distanceScalingFactor);
        
        planetPosition = [(position.x*v.distanceScalingFactor)/v.orbitScale, (position.y*v.distanceScalingFactor)/v.orbitScale, (position.z*v.distanceScalingFactor)/v.orbitScale]
        if(isFocused){
          if(viewType === 'click'){
            // props.onSetCameraFocus(position, data.diameter)
            // props.onSetCameraFocus(props.data)
          }                    
        }

        if(isFocuseSearch){
          if(searchText && data.name === searchText && viewType === 'search'){
            // props.onSetCameraFocus(meshRef.current.position, data.diameter)
          }
        }
    })


    useFrame((state, delta) => (meshRef.current.rotation.y += 0.01));
    return (
      <group>
        <mesh {...props} ref={meshRef}  onClick={() => {handlePlanetClick("click"); }} position={[initialPosition.x, initialPosition.y, initialPosition.z]}>
          <sphereGeometry args={[radius/v.scale, 100]} />
          <meshStandardMaterial  map={texture}/>

          {/* {meshRef && meshRef.current.position &&  */}
            {/* <Ring planet={props.data} planetPosition={planetPosition} /> */}
          {/* } */}
          
          
          <Html>
          <div className="planetDisplayName">
            <p  id="planetNameClicked"style={{fontSize:"12px", color: "white"}} onClick={() => {handlePlanetClick("click"); }}>{props.data.name}</p>
          </div>
          </Html>
          
        </mesh>

        
      </group>
    );
};

export default Planet